import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
  withXhr,
} from "@angular/common/http";
import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideStore } from "@ngrx/store";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import {
  WORKFLOW_RUNTIME_CONFIG,
  WORKFLOW_RUN_STORAGE,
} from "@los-workspace/workflow-runtime";
import { provideIndexedDb } from "ngx-indexed-db";

import { provideFlatpickrDefaults } from "angularx-flatpickr";

import { GOOGLE_MAPS_API_KEY } from "@shared/map/google-maps-api-key.token";
import { SKELETON_LOADER_CONFIG } from "@shared/skeleton-loader/skeleton-loader.config";
import { routes } from "./app.routes";
import { environment } from "../environments/environment";
import { indexReducer } from "./store/index.reducer";
import { AppService } from "./services/app.service";
import { authInterceptor } from "./services/auth.interceptor";
import { loanApplicationApiFeedbackInterceptor } from "./services/loan-application-api-feedback.interceptor";
import { LOS_INDEXED_DB_CONFIG } from "./core/indexed-db/los-indexed-db.config";
import { NgxIndexedDbWorkflowRunStorageAdapter } from "./core/indexed-db/ngx-indexed-db-workflow-run-storage.adapter";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withXhr(),
      withInterceptorsFromDi(),
      withInterceptors([
        authInterceptor,
        loanApplicationApiFeedbackInterceptor,
      ]),
    ),
    provideFlatpickrDefaults(),
    provideStore({ index: indexReducer }),
    AppService,
    {
      provide: WORKFLOW_RUNTIME_CONFIG,
      useValue: { apiUrl: environment.apiUrl },
    },
    {
      provide: SKELETON_LOADER_CONFIG,
      useValue: { enabled: environment.skeletonLoadersEnabled },
    },
    {
      provide: GOOGLE_MAPS_API_KEY,
      useValue: environment.googleMapsApiKey ?? "",
    },
    provideIndexedDb(LOS_INDEXED_DB_CONFIG),
    {
      provide: WORKFLOW_RUN_STORAGE,
      useExisting: NgxIndexedDbWorkflowRunStorageAdapter,
    },
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: "en",
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
  ],
};
